import { useQuery, UseQueryOptions } from 'react-query';
import { PhoneNumberSchemaService } from '@frontend/schema';
import { IO } from '../../types';
import { queryRequestKeys } from '../keys';

/**
 * Get list of assignees authorized to access messages with private phone numbers.
 */
export const useGetPhoneAuthorizedAssignees = <E = unknown, T = IO.GetPhoneAuthorizedAssignees['output']>(
  req: IO.GetPhoneAuthorizedAssignees['input'],
  options?: UseQueryOptions<IO.GetPhoneAuthorizedAssignees['output'], E, T>
) => {
  const queryKey = queryRequestKeys.privateAssignees(req);
  return useQuery<IO.GetPhoneAuthorizedAssignees['output'], E, T>(
    queryKey,
    () => PhoneNumberSchemaService.ListPhoneNumbersAuthorizedUsers(req),
    { ...options }
  );
};
